import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loader: React.FunctionComponent<{
  height?: string;
  className?: string;
  size?: 'sm';
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
}> = ({ height, className, size, variant }) => (
  <div
    style={{ height: `${height}` }}
    className={`d-flex align-items-center justify-content-center mt-2 ${className || ''}`}
  >
    <Spinner animation="border" variant={variant ? variant : 'primary'} {...(size ? { size } : {})} />
  </div>
);

Loader.defaultProps = {
  height: '100%',
};

export default Loader;
